<form [formGroup]="form">
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Sexo</mat-label>
      <mat-select
        matInput
        placeholder="Escolha o sexo"
        formControlName="gender"
      >
        <mat-option value="masculino">Masculino</mat-option>
        <mat-option value="feminino">Feminino</mat-option>
        <mat-option value="outros">Outros</mat-option>
        <mat-option value="none">Não prefiro informar</mat-option>
        <!--<mat-optgroup label="Outros gêneros">
                    <ng-container *ngFor="let gender of genders$ | async">
                        <mat-option [value]="gender.gender">{{ gender.gender }}</mat-option>
                    </ng-container>
                </mat-optgroup>-->
      </mat-select>
      <mat-error *ngIf="form.get('gender').errors?.required"
        >Por favor informe o sexo</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data de nascimento</mat-label>
      <input
        matInput
        type="text"
        mask="00/00/0000"
        inputmode="numeric"
        placeholder="Informe sua data de nascimento"
        formControlName="birthdate"
      />
      <mat-error *ngIf="form.get('birthdate').errors?.required"
        >Por favor informe a data de nascimento</mat-error
      >
    </mat-form-field>
  </div>

  <fieldset>
    <legend>Endereço</legend>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>CEP</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe seu cep"
          autocomplete="off"
          formControlName="zipCode"
          mask="00000-000"
          inputmode="numeric"
        />
        <mat-error *ngIf="form.get('zipCode').errors?.required"
          >Por favor informe o CEP</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Estado</mat-label>
        <mat-autocomplete
          #autoState="matAutocomplete"
          [displayWith]="displayState"
          (optionSelected)="onStateSelected($event)"
        >
          <ng-container *ngFor="let state of filteredStates$ | async">
            <mat-option [value]="state">{{ state.nome }}</mat-option>
          </ng-container>
        </mat-autocomplete>
        <input
          matInput
          type="text"
          placeholder="Informe o estado"
          autocomplete="off"
          formControlName="state"
          [matAutocomplete]="autoState"
        />
        <mat-error *ngIf="form.get('state').errors?.required"
          >Por favor informe o seu estado</mat-error
        >
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Cidade</mat-label>
        <mat-autocomplete #autoCity="matAutocomplete">
          <ng-container *ngFor="let city of filteredCities$ | async">
            <mat-option [value]="city.name">{{ city.name }}</mat-option>
          </ng-container>
        </mat-autocomplete>
        <input
          matInput
          type="text"
          placeholder="Informe a cidade"
          autocomplete="off"
          formControlName="city"
          [matAutocomplete]="autoCity"
        />
        <mat-error *ngIf="form.get('city').errors?.required"
          >Por favor informe a sua cidade</mat-error
        >
        <mat-hint>Escolha o estado para mostrar as cidades</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Bairro</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe seu bairro"
          autocomplete="off"
          formControlName="district"
        />
        <mat-error *ngIf="form.get('district').errors?.required"
          >Por favor informe o seu bairro</mat-error
        >
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Rua/avenida</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe a rua/avenida"
          autocomplete="off"
          formControlName="street"
        />
        <mat-error *ngIf="form.get('street').errors?.required"
          >Por favor informe o nome da sua rua</mat-error
        >
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Numero de residência</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe numero da sua residência"
          autocomplete="off"
          formControlName="number"
          inputmode="numeric"
        />
        <mat-error *ngIf="form.get('number').errors?.required"
          >Por favor informe o número da residência</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Complemento</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe o complemento"
          autocomplete="off"
          formControlName="complement"
        />
      </mat-form-field>
    </div>
  </fieldset>

  <!--<div class="row">
        <mat-checkbox color="primary" formControlName="acceptTerm">Aceito o uso das informações para fins de recrutamento.</mat-checkbox>
    </div>-->

  <div class="actions" style="margin-top: 10px">
    <button
      mat-raised-button
      type="submit"
      color="primary"
      class="custom-primary"
      (click)="onSubmit()"
      matStepperNext
    >
      Continuar
    </button>
    <button mat-raised-button color="primary" matStepperPrevious>Voltar</button>
  </div>
</form>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
